module.exports = __webpack_public_path__ + "img/albania.06ba1b7.webp";